import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import OnboardingContainer from "@/components/onboarding/OnboardingContainer/OnboardingContainer.vue";
import { useGetOnboardingNotificationsProperties } from "./useGetOnboardingNotificationsProperties";


export default /*#__PURE__*/_defineComponent({
  __name: 'OnboardingNotifications',
  setup(__props) {

const { notificationOnboardingProperties } =
  useGetOnboardingNotificationsProperties();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(OnboardingContainer, _normalizeProps(_guardReactiveProps(_unref(notificationOnboardingProperties))), null, 16))
}
}

})